export const GET_APPOINTMENTS = 'GET_APPOINTMENTS';
export const UPDATE_APPOINTMENT = 'UPDATE_APPOINTMENT';
export const UPDATE_REQUEST_APPOINTMENT = 'UPDATE_REQUEST_APPOINTMENT';
export const CLEAR_APPOINTMENTS = 'CLEAR_APPOINTMENTS';
export const SET_BRAND = 'SET_BRAND';
export const CLEAR_STATE = 'CLEAR_STATE';
export const CHANGE_ACTIVE = 'CHANGE_ACTIVE';
